/*--------------------------------------------*\
    Include Globally Useful JS Functions
\*--------------------------------------------*/
PluginJS.Functions = (function ($, root) {

  function send_ajax_request(args) {
    args.data.nonce = PluginJS.Variables.Ajax.nonce;
    $.post(PluginJS.Variables.Ajax.url, args.data, function (response) {
      response = JSON.parse(response);
      if (!response.hasOwnProperty('data')) { response.data = {}; }
      if (response.success && typeof args.success == 'function') {
        args.success(response.data);
      } else if (!response.success && typeof args.error == 'function') {
        args.error(response.data);
      }
    });
  }

  function wp_rest_request(args) {
    let ajax_args = {
      method: (args.method ?? 'GET').toString().toUpperCase(),
      url: `${PluginJS.Variables.WP_REST.root}${args.endpoint}`,
      data: args.data,
      contentType: 'application/json; charset=utf-8',
      beforeSend(xhr) {
        xhr.setRequestHeader('X-WP-Nonce', PluginJS.Variables.WP_REST.nonce);
      },
      success(data) {
        if (typeof args.success == 'function') {
          args.success(data);
        }
      },
      error(data) {
        if (typeof args.error == 'function') {
          args.error(data);
        }
      },
      complete(data) {
        if (typeof args.complete == 'function') {
          args.complete(data);
        }
      }
    };
    if (ajax_args.method != 'GET') {
      ajax_args.dataType = 'json';
      ajax_args.data = JSON.stringify(ajax_args.data);
    }
    jQuery.ajax(ajax_args);
  }

  function get_query_parameter(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&#]' + name + '(=([^&#]*)|&|#|$)'),
      results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
  }

  let scrollbar_width = null;
  // taken from https://stackoverflow.com/questions/13382516/getting-scroll-bar-width-using-javascript
  function get_scrollbar_width() {
    if (scrollbar_width === null) {
      let outer = document.createElement('div');
      outer.style.visibility = 'hidden';
      outer.style.overflow = 'scroll';
      outer.style.msOverflowStyle = 'scrollbar';
      document.body.appendChild(outer);
      let inner = document.createElement('div');
      outer.appendChild(inner);
      scrollbar_width = (outer.offsetWidth - inner.offsetWidth);
      outer.parentNode.removeChild(outer);
    }
    return scrollbar_width;
  }

  document.querySelector(':root').style.setProperty('--scrollbar-width', `${get_scrollbar_width()}px`);

  return {
    send_ajax_request,
    wp_rest_request,
    get_query_parameter,

  }

})(jQuery, this);
PluginJS.Media_Queries = (function ($) {

  let breakpoints_obj = PluginJS.Variables.Screen_Sizes;

  // JS objects cannot be relied on for ordering
  // rebuild into array of objects and sort
  let breakpoints = [];
  $.each(breakpoints_obj, function (size, px) {
    breakpoints.push({ size, px });
  });
  breakpoints.sort(function (a, b) {
    return a.px - b.px;
  });

  let queries = {};
  $.each(breakpoints, function (index, obj) {
    queries[obj.size] = window.matchMedia(`( min-width: ${obj.px}px )`);
    queries[obj.size].addListener(breakpoint_changed);
  });

  let previous_size = null;
  let current_size;
  calculate_current_size();
  function calculate_current_size() {
    let max_matched_size = 'xs';
    $.each(queries, function (size, query) {
      if (query.matches) {
        max_matched_size = size;
        return;
      }
      return false;
    });
    current_size = max_matched_size;
  }

  function breakpoint_changed() {
    previous_size = current_size;
    calculate_current_size();
    $(window).trigger('breakpoint_changed', [current_size, previous_size]);
  }

  return {
    get_current_size: function () {
      return current_size;
    },
    is_at_least: function (size) {
      return queries[size].matches;
    },
  };

})(jQuery);

(function ($) {

  const $body = $('body');
  const $header = $('#site-header');
  const $menu = $('#menu-wrap');
  const $toggle = $('#mobile-menu-toggle');
  const speed = 300;

  const menu_bp = $header.data('menu-bp');


  function is_mobile() {
    return $toggle.is(':visible');
  }

  $menu.on('click', 'a[href^="#"]', function () {
    if (is_mobile()) {
      focus_trap.deactivate();
    }
  });

  // create focus trap
  const focus_trap = focusTrap.createFocusTrap($header.get(0), {
    onActivate() {
      $toggle.addClass('is-active');
      $menu.addClass('visible');
      $body.addClass('menu-open');
    },
    onDeactivate() {
      $toggle.removeClass('is-active');
      $body.removeClass('menu-open');
      setTimeout(function () {
        $menu.removeClass('visible');
      }, speed);
    },
    initialFocus: $toggle.get(0),
  });
  // toggle mobile menu on hamburger click
  $toggle.click(() => {
    $body.hasClass('menu-open') ? focus_trap.deactivate() : focus_trap.activate();
  });


  function resize() {
    $header.toggleClass('mobile', !PluginJS.Media_Queries.is_at_least(menu_bp));

    const adminBarHeight = $('#wpadminbar').length ? $('#wpadminbar').outerHeight() : 0;
    // document.querySelector(':root').style.setProperty('--header-height', `${$header.outerHeight(true)}px`);
    // let spacing = $header.outerHeight(true);
    // document.querySelector(':root').style.setProperty('--header-height', `${spacing}px`);


    let spacing = $header.outerHeight(false);
    document.querySelector(':root').style.setProperty('--header-height', `${spacing}px`);

    if (adminBarHeight) {
      $header.css({
        marginTop: `${adminBarHeight}px`
      });
    } else {
      $header.css({
        marginTop: ''
      });
    }
    $menu.removeClass('mobile-transition-enabled');
    setTimeout(function () {
      $menu.addClass('mobile-transition-enabled');
    }, 0);
    if (PluginJS.Media_Queries.is_at_least(menu_bp)) {
      focus_trap.deactivate();
      $('button.sub-menu-toggle').closest('li').each(function () {
        set_submenu_open($(this), false);
      });
    }
  }


  // init header pad height and set header to fixed
  resize();
  // $header.addClass('fixed');
  // trigger height recalculation on breakpoint change
  $(window).on('breakpoint_changed', resize);

  // observe admin bar addition/removal
  const adminBarObserver = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.id === 'wpadminbar') {
          resize();
        }
      });
    });
  });
  adminBarObserver.observe(document.body, { childList: true });
  if (document.getElementById('wpadminbar')) {
    resize();
  }

  // toggle mobile menu on hamburger click
  // $toggle.click(() => {
  //   $body.hasClass('menu-open') ? focus_trap.deactivate() : focus_trap.activate();
  // });


  // function to set submenus open/close
  function set_submenu_open($li, opening) {
    let $btn = $('> .link-wrap button.sub-menu-toggle', $li);
    if (!$btn.length) { return; }
    let $submenu = $(`#${$btn.attr('aria-controls')}`);
    if (!$submenu.length) { return; }
    $btn.attr('aria-expanded', opening ? 'true' : 'false');
    $submenu.attr('aria-hidden', opening ? 'false' : 'true')[opening ? 'slideDown' : 'slideUp'](speed);
  }


  // toggle submenus on click of caret btns
  $menu.on('click', 'button.sub-menu-toggle', function () {
    set_submenu_open($(this).closest('li'), $(this).attr('aria-expanded') == 'false');
  });
  $menu.on('mouseenter', 'li.menu-item-has-children', function () {
    if (is_mobile()) { return; }
    set_submenu_open($(this), true);
  });


  // close submenu on tab out
  $menu.on('focusout', 'li.menu-item-has-children', function (e) {
    if (is_mobile() || $.contains(this, e.relatedTarget)) { return; }
    set_submenu_open($(this), false);
  });
  $menu.on('mouseleave', 'li.menu-item-has-children', function (e) {
    if (is_mobile()) { return; }
    set_submenu_open($(this), false);
  });


  // treat click of a custom link '#' menu item as clicking its submenu toggle
  $menu.on('click', 'a[href="#"]', function (e) {
    e.preventDefault();
    let $btn = $('+ .sub-menu-toggle', this);
    if ($btn.length) {
      $btn.click();
    }
  });

})(jQuery);